<template>
  <mdb-container class="gp-has-header text-left">
    <h6>Current Backend: {{version.backend}}</h6>
    <mdb-input v-model="newBackend" label="New Backend Version" />
    <h6>Current Frontend: {{version.frontend}}</h6>
    <mdb-input v-model="newFrontend" label="New Frontend Version" />
    <mdb-btn @click="getIssues">Associated Issues</mdb-btn>
    <mdb-btn @click="applyStamp">Apply Stamp</mdb-btn>

    <div v-if="issues.length>0">
      <h2>Associated Issues</h2>
      <div v-for="i in issues">
        <a href="" @click.prevent="$router.push('/issues/show/' + i.id)">{{i.id}} -- {{i.title}}</a>
      </div>
    </div>
  </mdb-container>

</template>
<script>
  import api from '../../services/groupsPlaceApi.js'
  import {
    mdbContainer,
    mdbInput,
    mdbBtn
  } from 'mdbvue';
  import Vue from "vue";

  export default {
    name: "system-stamper",
    display: "Stamp Release",
    order: 1,
    components: {
      mdbContainer,
      mdbInput,
      mdbBtn,

    },
    computed: {
      userDetails: function () {
        return this.$store.state.userDetails
      }
    },
    async mounted() {
      await this.$store.dispatch("setExecuting", true)
      api.get("/public/version").then(
        (details) => {
          this.version.frontend = details.data.frontend
          this.version.backend = details.data.backend
        },
        (error) => {
          this.$notify.error({message: "Error getting current version."})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    data() {
      return {
        version: {frontend: "?", backend: "?" },
        newBackend: "",
        newFrontend: "",
        issues: []
      }
    },
    methods: {
      getIssues() {
        this.$store.dispatch("setExecuting", true)
        api.get("/issue/listByStamp?be=" + this.newBackend + "&fe=" + this.newFrontend).then(
          (details) => {
            this.issues = details.data
          },
          (error) => {
            this.issues = []
            if (error.response.status == 403 || error.response.status == 401) this.$router.push("/403")
            else this.$notify.error({message: error.response.data})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      applyStamp() {
        this.$store.dispatch("setExecuting", true)
        api.get("/issue/applyStamp?be=" + this.newBackend + "&fe=" + this.newFrontend).then(
          (details) => {
            if (this.newFrontend) this.version.frontend = this.newFrontend
            if (this.newBackend) this.version.backend = this.newBackend
            this.newFrontend = ""
            this.newBackend = ""
            this.issues = []
            this.$notify.success({message:"Done!"})
          },
          (error) => {
            this.issues = []
            if (error.response.status == 403 || error.response.status == 401) this.$router.push("/403")
            else this.$notify.error({message: error.response.data})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      }
    }

  }
  ;
</script>
